import React from "react";
import { usePaidBookingStats } from "../../booking/hooks/usePaidBookingStats";

export default function BookedMembersTicker() {
  const { paidAttendees, paidBookings, loading, error } = usePaidBookingStats({
    enabled: true,
  });

  if (loading) {
    return (
      <div className="jp-stat-widget jp-stat-widget--members">
        <div className="jp-stat-label">Booked so far</div>
        <div className="jp-stat-value">…</div>
        <div className="jp-stat-sub">Loading attendees</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="jp-stat-widget jp-stat-widget--members">
        <div className="jp-stat-label">Booked so far</div>
        <div className="jp-stat-value">–</div>
        <div className="jp-stat-sub">Unavailable</div>
      </div>
    );
  }

  return (
    <div className="jp-stat-widget jp-stat-widget--members">
      <div className="jp-stat-label">Booked so far</div>
      <div className="jp-stat-value">{paidAttendees}</div>
      <div className="jp-stat-sub">
        {paidBookings} paid booking{paidBookings === 1 ? "" : "s"}
      </div>
    </div>
  );
}